import React, { useState, useEffect } from 'react';
import {
    Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField,
    Table, TableBody, TableCell, TableHead, TableRow, Typography,
    Paper, Stack, Grid, CircularProgress, Card, IconButton, InputAdornment, MenuItem
} from '@mui/material';
import { collection, query, getDocs, addDoc, updateDoc, doc, deleteDoc, Timestamp } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import { toast } from 'react-toastify';
import TablePagination from '@mui/material/TablePagination';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Fiananceheader from './Fiananceheader';

const FiananceCust = () => {
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        address: '',
        city: '',
        state: '',
        jamindar_name1: '',
        jamindar_name2: '',
        jamindaradrees1: '',
        jamindarmobile1: '',
        jamindaradress2: '',
        jamindarmobile2: '',
        status: 'Active',
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [editMode, setEditMode] = useState(false);
    const [editId, setEditId] = useState(null);

    useEffect(() => {
        fetchCustomers();
    }, []);

    const fetchCustomers = async () => {
        try {
            const q = query(collection(db, 'fianancecustomers'));
            const snapshot = await getDocs(q);
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setCustomers(data);
        } catch (error) {
            console.error("Error fetching customers:", error);
            toast.error("Error fetching customers.");
        }
    };

    const handleOpen = () => {
        setFormData({
            name: '',
            mobile: '',
            email: '',
            address: '',
            city: '',
            state: '',
            jamindar_name1: '',
            jamindar_name2: '',
            jamindaradrees1: '',
            jamindarmobile1: '',
            jamindaradress2: '',
            jamindarmobile2: '',
            status: 'Active',
        });
        setErrors({});
        setEditMode(false);
        setEditId(null);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setLoading(false);
        setErrors({});
    };

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const validate = () => {
        let temp = {};
        temp.name = formData.name ? "" : "Name is required";
        temp.mobile = /^[0-9]{10}$/.test(formData.mobile) ? "" : "Enter valid 10-digit mobile number";

        setErrors(temp);
        return Object.values(temp).every(x => x === "");
    };

    const handleSubmit = async () => {
        if (!validate()) return;
        setLoading(true);

        try {
            const propid = auth.currentUser?.uid;
            let newCustData = { ...formData, propid };

            if (editMode && editId) {
                // UPDATE document
                await updateDoc(doc(db, 'fianancecustomers', editId), newCustData);
                toast.success("Customer updated successfully!");
            } else {
                // ADD document
                const maxId = customers.length > 0
                    ? Math.max(...customers.map(c => c.custID || 0))
                    : 0;
                const newCustId = maxId + 1;

                // Add `custID` and the new `addeddate` field
                newCustData = { ...newCustData, custID: newCustId, addeddate: Timestamp.now() };

                await addDoc(collection(db, 'fianancecustomers'), newCustData);
                toast.success("Customer added successfully!");
            }

            fetchCustomers();
            handleClose();
        } catch (err) {
            console.error(err);
            toast.error("Error: " + err.message);
        }

        setLoading(false);
    };

    const handleEdit = (cust) => {
        setFormData({
            name: cust.name || '',
            mobile: cust.mobile || '',
            email: cust.email || '',
            address: cust.address || '',
            city: cust.city || '',
            state: cust.state || '',
            jamindar_name1: cust.jamindar_name1 || '',
            jamindar_name2: cust.jamindar_name2 || '',
            jamindaradrees1: cust.jamindaradrees1 || '',
            jamindarmobile1: cust.jamindarmobile1 || '',
            jamindaradress2: cust.jamindaradress2 || '',
            jamindarmobile2: cust.jamindarmobile2 || '',
            status: cust.status || 'Active',
        });
        setEditId(cust.id);
        setEditMode(true);
        setOpen(true);
    };

    const handleDelete = async (id) => {
        try {
            await deleteDoc(doc(db, 'fianancecustomers', id));
            toast.success("Customer deleted successfully!");
            fetchCustomers();
        } catch (err) {
            console.error(err);
            toast.error("Error deleting customer.");
        }
    };

    const filtered = customers.filter(cust =>
        cust.name.toLowerCase().includes(search.toLowerCase()) ||
        cust.mobile.includes(search) ||
        cust.email.toLowerCase().includes(search.toLowerCase())
    );

    const paginated = filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <Box>
            <Fiananceheader />
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
                <Button variant="contained" onClick={handleOpen}>Add कर्जदार </Button>
                <Typography variant="h5" fontWeight="bold">कर्जदार  Management</Typography>
            </Stack>

            <TextField
                placeholder="Search by name, mobile, or email"
                variant="outlined"
                size="small"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    )
                }}
                sx={{ mb: 2, width: '400px' }}
            />

            <Card>
                <Paper>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#e0e0e0' }}>
                                <TableCell>Cust ID</TableCell>
                                <TableCell>Actions</TableCell>
                                <TableCell>नाव </TableCell>
                                <TableCell>मोबाइल</TableCell>
                                <TableCell>ई-मेल </TableCell>
                                <TableCell>ऍड्रेस </TableCell>
                                <TableCell>सिटी </TableCell>
                                <TableCell>स्टेट </TableCell>
                                <TableCell>साक्षीदार  1</TableCell>
                                <TableCell>साक्षीदार  2</TableCell>
                                <TableCell>स्टेटस </TableCell>
                                <TableCell>दिनांक </TableCell> {/* Added the new column header */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginated.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={12} align="center">No karjdars found</TableCell>
                                </TableRow>
                            ) : (
                                paginated.map((cust) => (
                                    <TableRow key={cust.id}>
                                        <TableCell>{cust.custID}</TableCell>
                                        <TableCell>
                                            <Stack direction="row" spacing={1}>
                                                <IconButton color="primary" onClick={() => handleEdit(cust)}>
                                                    <EditIcon />
                                                </IconButton>
                                                <IconButton color="error" onClick={() => handleDelete(cust.id)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Stack>
                                        </TableCell>
                                        <TableCell>{cust.name}</TableCell>
                                        <TableCell>{cust.mobile}</TableCell>
                                        <TableCell>{cust.email}</TableCell>
                                        <TableCell>{cust.address}</TableCell>
                                        <TableCell>{cust.city}</TableCell>
                                        <TableCell>{cust.state}</TableCell>
                                        <TableCell>{cust.jamindar_name1}</TableCell>
                                        <TableCell>{cust.jamindar_name2}</TableCell>
                                        <TableCell>
                                            <Box component="span" sx={{
                                                color: cust.status === 'Active' ? 'green' : 'red',
                                                fontWeight: 'bold',
                                            }}>
                                                {cust.status}
                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            {cust.addeddate && new Date(cust.addeddate.seconds * 1000).toLocaleDateString()}
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>

                    <TablePagination
                        rowsPerPageOptions={[10, 20, 30]}
                        component="div"
                        count={filtered.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={(e, newPage) => setPage(newPage)}
                        onRowsPerPageChange={(e) => {
                            setRowsPerPage(parseInt(e.target.value, 10));
                            setPage(0);
                        }}
                    />
                </Paper>
            </Card>

            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>{editMode ? 'Edit' : 'Add'} कर्जदार </DialogTitle>
                <DialogContent dividers>
                    <Grid container className="row">
                        <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                            <TextField
                                label="कर्जदार  नाव "
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                fullWidth size="small"
                                required
                                error={!!errors.name}
                                helperText={errors.name}
                            />
                        </Grid>
                        <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                            <TextField
                                label="मोबाइल"
                                name="mobile"
                                value={formData.mobile}
                                onChange={handleChange}
                                fullWidth size="small"
                                required
                                error={!!errors.mobile}
                                helperText={errors.mobile}
                            />
                        </Grid>
                        <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                            <TextField
                                label="ई-मेल"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                fullWidth size="small"
                            />
                        </Grid>
                        <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                            <TextField
                                label="ऍड्रेस"
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                fullWidth size="small"
                                required
                                error={!!errors.address}
                                helperText={errors.address}
                            />
                        </Grid>
                        <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                            <TextField
                                label="सिटी"
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                                fullWidth size="small"
                                required
                                error={!!errors.city}
                                helperText={errors.city}
                            />
                        </Grid>
                        <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                            <TextField
                                label="स्टेट"
                                name="state"
                                value={formData.state}
                                onChange={handleChange}
                                fullWidth size="small"
                                required
                                error={!!errors.state}
                                helperText={errors.state}
                            />
                        </Grid>
                        {/* साक्षीदार Fields */}
                        <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                            <TextField
                                label="साक्षीदार 1 नाव "
                                name="jamindar_name1"
                                value={formData.jamindar_name1}
                                onChange={handleChange}
                                fullWidth size="small"
                            />
                        </Grid>
                        <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                            <TextField
                                label="साक्षीदार 1 पत्ता "
                                name="jamindaradrees1"
                                value={formData.jamindaradrees1}
                                onChange={handleChange}
                                fullWidth size="small"
                            />
                        </Grid>
                        <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                            <TextField
                                label="साक्षीदार 1 मोबाईल "
                                name="jamindarmobile1"
                                value={formData.jamindarmobile1}
                                onChange={handleChange}
                                fullWidth size="small"
                            />
                        </Grid>
                        <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                            <TextField
                                label="साक्षीदार 2 नाव "
                                name="jamindar_name2"
                                value={formData.jamindar_name2}
                                onChange={handleChange}
                                fullWidth size="small"
                            />
                        </Grid>
                        <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                            <TextField
                                label="साक्षीदार 2 पत्ता "
                                name="jamindaradress2"
                                value={formData.jamindaradress2}
                                onChange={handleChange}
                                fullWidth size="small"
                            />
                        </Grid>
                        <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                            <TextField
                                label="साक्षीदार 2 मोबाईल "
                                name="jamindarmobile2"
                                value={formData.jamindarmobile2}
                                onChange={handleChange}
                                fullWidth size="small"
                            />
                        </Grid>
                        <Grid className="col-sm-4 mb-4" item xs={12} sm={6}>
                            <TextField
                                label="स्टेटस "
                                name="status"
                                select
                                value={formData.status}
                                onChange={handleChange}
                                fullWidth size="small"
                            >
                                <MenuItem value="Active">Active</MenuItem>
                                <MenuItem value="Inactive">Inactive</MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="error">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        disabled={loading}
                        sx={{ ml: 2 }}
                    >
                        {loading ? <CircularProgress size={24} /> : (editMode ? "Update" : "Add")}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default FiananceCust;